const servicesDetailData = [
  {
    id: 1,
    name: "Electrical Installation & Systems",
    slug: "electrical-installation",
    description: "Professional electrical installation and system setup for residential and commercial properties.",
    image: "/images/services/electrical-installation.jpeg",
    buttonText: "Get a Quote",
    category: "commercial",
    hero: {
      heading: "Emergency Repair",
      subheading: "Swift 24/7 electrical repair services for outages, sparks, or burning smells at any hour, any day.",
      features: [
        { title: "Fault Fixes", desc: "Rapid diagnosis and repair of electrical faults" },
        { title: "Quick Response", desc: "Emergency team dispatched within 30 minutes" },
        { title: "Safety Checks", desc: "Comprehensive safety inspections and testing" }
      ],
      details: "Our certified electricians provide complete electrical installation for new builds, renovations, and commercial fit-outs. From wiring to distribution boards, we ensure code-compliant, safe, and efficient electrical systems tailored to your needs."
    },
    products: [
      { name: "Circuit Breakers", image: "/images/supplier/image11.jpeg" },
      { name: "Distribution Boards", image: "/images/supplier/image11.jpeg" },
      { name: "Wiring & Cables", image: "/images/supplier/image9.jpeg" }
    ]
  },
  {
    id: 2,
    name: "CCTV & Alarm Installation",
    slug: "cctv-alarms",
    description: "State-of-the-art security systems with CCTV cameras and alarm installations.",
    image: "/images/services/cctv-alarms.jpeg",
    buttonText: "Secure Your Property",
    category: "residential",
    hero: {
      heading: "Security Systems",
      subheading: "Advanced CCTV and alarm solutions to monitor and protect your property around the clock.",
      features: [
        { title: "HD Cameras", desc: "High-definition surveillance with night vision" },
        { title: "Remote Access", desc: "View your property from anywhere via smartphone" },
        { title: "Motion Detection", desc: "Instant alerts when movement is detected" }
      ],
      details: "We design and install comprehensive security systems including IP cameras, DVR/NVR recording, motion sensors, and smart alarm systems. Our solutions provide peace of mind with 24/7 monitoring capabilities for homes and businesses."
    },
    products: [
      { name: "CCTV Cameras", image: "/images/supplier/image4.jpeg" },
      { name: "DVR Systems", image: "/images/supplier/image5.jpeg" },
      { name: "Alarm Kits", image: "/images/supplier/image6.jpeg" }
    ]
  },
  {
    id: 3,
    name: "Solar System & Installation",
    slug: "solar-installation",
    description: "Complete solar system installations for sustainable energy.",
    image: "/images/services/solar-installation.jpeg",
    buttonText: "Go Solar Today",
    category: "residential",
    hero: {
      heading: "Solar Energy",
      subheading: "Harness the power of the sun with our complete solar system design and installation services.",
      features: [
        { title: "Panel Installation", desc: "Professional mounting and wiring of solar panels" },
        { title: "Inverter Setup", desc: "Efficient power conversion for your home" },
        { title: "Battery Storage", desc: "Store excess energy for nighttime use" }
      ],
      details: "Our solar experts provide end-to-end solar solutions from consultation and design to installation and maintenance. We help you reduce electricity bills and carbon footprint with high-efficiency solar panels, inverters, and battery storage systems."
    },
    products: [
      { name: "Solar Panels", image: "/images/supplier/image1.jpeg" },
      { name: "Solar Inverters", image: "/images/supplier/image2.jpeg" },
      { name: "Solar Batteries", image: "/images/supplier/image3.jpeg" }
    ]
  },
  {
    id: 4,
    name: "Electrical Designs",
    slug: "electrical-designs",
    description: "Custom electrical design solutions tailored to your needs.",
    image: "/images/services/electrical-designs.jpeg",
    buttonText: "Design Consultation",
    category: "industrial",
    hero: {
      heading: "Design & Planning",
      subheading: "Professional electrical design and planning services for residential, commercial, and industrial projects.",
      features: [
        { title: "CAD Design", desc: "Detailed electrical layout and schematic designs" },
        { title: "Load Analysis", desc: "Accurate power load calculations and planning" },
        { title: "Compliance", desc: "All designs meet regulatory standards and codes" }
      ],
      details: "Our electrical design team creates comprehensive plans for new constructions and renovations. We provide detailed schematics, load calculations, and material specifications to ensure your electrical system is safe, efficient, and future-proof."
    },
    products: [
      { name: "Smart Switches", image: "/images/supplier/image12.jpeg" },
      { name: "Electrical Panels", image: "/images/supplier/image11.jpeg" },
      { name: "Network Cables", image: "/images/supplier/image9.jpeg" }
    ]
  },
  {
    id: 5,
    name: "Internet & Network Installation",
    slug: "network-installation",
    description: "High-speed internet and network setup for homes and offices.",
    image: "/images/services/network-installation.jpeg",
    buttonText: "Get Connected",
    category: "commercial",
    hero: {
      heading: "Network Solutions",
      subheading: "High-speed internet and professional network infrastructure for seamless connectivity.",
      features: [
        { title: "WiFi Setup", desc: "Whole-home and office wireless coverage" },
        { title: "Structured Cabling", desc: "Organized Cat6/Cat7 cable installations" },
        { title: "Network Security", desc: "Firewall and secure network configuration" }
      ],
      details: "We provide complete network installation services including router configuration, structured cabling, WiFi optimization, and network security setup. Stay connected with reliable, high-speed internet infrastructure designed for your specific needs."
    },
    products: [
      { name: "Network Routers", image: "/images/supplier/image8.jpeg" },
      { name: "Network Cables", image: "/images/supplier/image9.jpeg" },
      { name: "WiFi Extenders", image: "/images/supplier/image8.jpeg" }
    ]
  },
  {
    id: 6,
    name: "Electric Fence Installation",
    slug: "electric-fence",
    description: "Secure your perimeter with professional electric fence installations.",
    image: "/images/services/electric-fence.jpeg",
    buttonText: "Secure Perimeter",
    category: "industrial",
    hero: {
      heading: "Perimeter Security",
      subheading: "Professional electric fence installation for complete property protection and deterrence.",
      features: [
        { title: "Energizer Setup", desc: "High-tensile electric fence energizers" },
        { title: "Perimeter Design", desc: "Custom fence layout for your property" },
        { title: "Safety Compliance", desc: "All installations meet safety regulations" }
      ],
      details: "We install durable and effective electric fence systems for residential, commercial, and agricultural properties. Our solutions provide reliable perimeter security with professional installation and ongoing maintenance support."
    },
    products: [
      { name: "Electric Fence", image: "/images/supplier/image7.jpeg" },
      { name: "Energizers", image: "/images/supplier/image7.jpeg" },
      { name: "Alarm Systems", image: "/images/supplier/image6.jpeg" }
    ]
  },
  {
    id: 7,
    name: "TV Installation",
    slug: "tv-installation",
    description: "Professional TV mounting and installation services for your entertainment.",
    image: "/images/services/tv-installation.jpeg",
    buttonText: "Install Now",
    category: "residential",
    hero: {
      heading: "Home Entertainment",
      subheading: "Professional TV mounting and home theater setup for the ultimate viewing experience.",
      features: [
        { title: "Wall Mounting", desc: "Secure mounting for all TV sizes and types" },
        { title: "Cable Management", desc: "Clean, hidden cable routing solutions" },
        { title: "Sound Setup", desc: "Home theater and soundbar configuration" }
      ],
      details: "Our technicians provide professional TV installation services including wall mounting, cable concealment, and home theater setup. We ensure your entertainment system is installed safely, neatly, and optimized for the best viewing experience."
    },
    products: [
      { name: "TV Mounts", image: "/images/supplier/image10.jpeg" },
      { name: "HDMI Cables", image: "/images/supplier/image9.jpeg" },
      { name: "Smart Switches", image: "/images/supplier/image12.jpeg" }
    ]
  },
  {
    id: 8,
    name: "Electronics Repair",
    slug: "electronics-repair",
    description: "Expert repair for smartphones, radios, extensions, and more.",
    image: "/images/services/electronics-repair.jpeg",
    buttonText: "Get Repair",
    category: "commercial",
    hero: {
      heading: "Device Repair",
      subheading: "Fast and reliable electronics repair services for all your devices and appliances.",
      features: [
        { title: "Diagnostics", desc: "Thorough testing to identify all issues" },
        { title: "Component Repair", desc: "Expert soldering and component replacement" },
        { title: "Quality Parts", desc: "Genuine replacement parts for lasting repairs" }
      ],
      details: "Our skilled technicians repair a wide range of electronic devices including smartphones, TVs, radios, home appliances, and extension cables. We provide fast turnaround times with quality workmanship and affordable pricing."
    },
    products: [
      { name: "Smart Switches", image: "/images/supplier/image12.jpeg" },
      { name: "Electrical Panels", image: "/images/supplier/image11.jpeg" },
      { name: "Wiring & Cables", image: "/images/supplier/image9.jpeg" }
    ]
  }
];

export default servicesDetailData;
